module.exports = __webpack_public_path__ + "img/loading.6473b516.gif";